import script from "./ShipInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShipInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./ShipInfoView.vue?vue&type=style&index=0&id=6d7d07b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7d07b6"]])

export default __exports__